import { SubscriptionType } from "@components/_subscription/helpers/constants"
import { PlanCardUsp } from "@components/_subscription/PlanCardUsp"
import { Box } from "@components/Box"
import { Button } from "@components/ui/button"
import { ModalOrSidebar } from "@components/ui/modal-sidebar"
import { Text } from "@components/ui/typograhpy/Text"
import { useGetSubscriptionDetails } from "@lib/hooks/use-get-subscription-details"
import { usePlans } from "@lib/hooks/use-plans"
import { addMonths, format } from "date-fns"
import { useRouter } from "next/router"
import { useEffect, useState } from "react"

const SubscriptionCongratulation = () => {
  const [open, setOpen] = useState(false)
  const router = useRouter()

  const { data: plans } = usePlans()
  const planDetail =
    plans.length && router.query.subscribed_plan
      ? plans.find((p) =>
          p.name
            ?.toLowerCase()
            .includes((router.query.subscribed_plan as string).toLowerCase()),
        )
      : null

  const { data: subscriptionDetails } = useGetSubscriptionDetails()
  const subscriptionDetail =
    subscriptionDetails[router.query.subscribed_plan as SubscriptionType]

  useEffect(() => {
    if (
      router.query.subscription === "success" &&
      subscriptionDetail // BASIC | BUSINESS
    ) {
      setOpen(true)
      window?.history.replaceState({}, document.title, window.location.pathname)
    }
  }, [router.query, subscriptionDetail])

  if (
    !router.query.subscribed_plan ||
    !router.query.purchase_time ||
    !subscriptionDetail
  ) {
    return null
  }

  if (!planDetail) {
    return null
  }

  // Use purchase_time in query to get the approximate renew date,
  // since we cannot make sure that the stripe webhook is triggered before the user is redirected to the success page
  const renewDate = format(
    addMonths(new Date(router.query.purchase_time as string), 1),
    "MMMM do",
  )

  return (
    <ModalOrSidebar title="Congratulations" open={open} onOpenChange={setOpen}>
      <Text variant="regular">
        You have successfully subscribed to the Viesus{" "}
        {router.query.subscribed_plan} plan. Take a look at the benefits of your
        subscription:
      </Text>
      <Box className="bg-opacity mx-0 my-4 flex flex-col gap-6 p-6">
        <div>
          <Text variant="special">
            {(
              planDetail?.monthlyCreditsAmount ||
              subscriptionDetail.initialCredit
            ).toLocaleString("nl-nl")}{" "}
            credits
          </Text>
          <Text variant="regular" className="text-shade-400">
            {planDetail?.monthlyPrice || subscriptionDetail.monthlyPrice} /
            month
          </Text>
          <Text variant="regular" className="text-shade-400">
            Renews {renewDate}
          </Text>
        </div>
        <ul>
          {subscriptionDetail.usps.map((usp, index) => {
            let upsText = usp

            if (
              upsText.includes("[creditAmount]") &&
              planDetail.topupCreditsAmount
            ) {
              upsText = upsText.replace(
                "[creditAmount]",
                planDetail.topupCreditsAmount.toString(),
              )
            }

            return <PlanCardUsp key={index}>{upsText}</PlanCardUsp>
          })}
        </ul>
      </Box>
      <Text variant="small" className="text-shade-500 mb-2">
        You can cancel your subscription at any time.
      </Text>
      <Button variant="primary" className="mt-8" onClick={() => setOpen(false)}>
        Got it
      </Button>
    </ModalOrSidebar>
  )
}

export default SubscriptionCongratulation
